module.exports = __webpack_public_path__ + "img/img_mainland_account_open_3.4c445994.png";